import { render, staticRenderFns } from "./clientItem.vue?vue&type=template&id=45abda26&scoped=true&"
import script from "./clientItem.vue?vue&type=script&lang=js&"
export * from "./clientItem.vue?vue&type=script&lang=js&"
import style0 from "./clientItem.vue?vue&type=style&index=0&id=45abda26&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45abda26",
  null
  
)

export default component.exports